import React, {useState} from 'react'
import FonctionDisplayKey from '../FonctionDisplayKey/FonctionDisplayKey'

const ContainerUseEffectCWU = () => {

    const [show, SetShow] = useState(true)

    const btnDisplay = show? 'Cacher' : 'aficher'

    return (
        <div className="text-center ">
            <button className="btn btn-primary m-3" onClick={() => SetShow(!show)}>{btnDisplay}</button>
              
              {show && < FonctionDisplayKey />}
              
        </div>
    )
}

export default ContainerUseEffectCWU
